import {BBModel} from "../bb_model";

const clinic = {
    query(params) {
        const {company} = params;

        return new Promise((resolve, reject) => {
            if (params.id) { // request for a single one
                company.$get('clinics', params).then((clinic) => {
                        clinic = new BBModel.Clinic(clinic);
                        return resolve(clinic);
                    }
                    , err => reject(err));
            } else {
                company.$get('clinics', params).then(collection =>
                        collection.$get('clinics').then((clinics) => {
                                clinics = (Array.from(clinics).map(s => new BBModel.Clinic(s)));
                                return resolve(clinics);
                            }
                            , err => reject(err))

                    , err => reject(err));
            }
        });
    }
};


export {
    clinic
}

